import React, { useMemo } from "react";
import { interpolate, useCurrentFrame, useVideoConfig, random } from "remotion";

export const KineticTypeBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();

  // Create a technical grid with animated pattern
  const gridShift = (frame * 0.5) % 100;

  // Generate some deterministic technical nodes
  const nodes = useMemo(() => {
    return new Array(15).fill(0).map((_, i) => ({
      x: random(`node-x-${i}`) * width,
      y: random(`node-y-${i}`) * height,
      size: 4 + random(`node-s-${i}`) * 6,
      opacityBase: 0.2 + random(`node-o-${i}`) * 0.4,
      driftX: (random(`node-dx-${i}`) - 0.5) * 40,
      driftY: (random(`node-dy-${i}`) - 0.5) * 40,
    }));
  }, [width, height]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width,
        height,
        backgroundColor: "#050814",
        overflow: "hidden",
      }}
    >
      {/* SVG Grid Pattern */}
      <svg
        width="100%"
        height="100%"
        style={{ position: "absolute", opacity: 0.15 }}
      >
        <defs>
          <pattern
            id="kinetic-grid"
            width="100"
            height="100"
            patternUnits="userSpaceOnUse"
            patternTransform={`translate(${gridShift}, ${gridShift})`}
          >
            <path
              d="M 100 0 L 0 0 0 100"
              fill="none"
              stroke="#22D3EE"
              strokeWidth="1"
            />
            <circle cx="0" cy="0" r="2" fill="#BEF264" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#kinetic-grid)" />
      </svg>

      {/* Drifting Technical Nodes */}
      {nodes.map((node, i) => {
        const driftX = interpolate(
          frame % 300,
          [0, 150, 300],
          [0, node.driftX, 0]
        );
        const driftY = interpolate(
          frame % 300,
          [0, 150, 300],
          [0, node.driftY, 0]
        );

        const pulse = Math.sin(frame * 0.05 + i) * 0.2 + 0.8;

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: node.x + driftX,
              top: node.y + driftY,
              width: node.size,
              height: node.size,
              borderRadius: "50%",
              backgroundColor: i % 3 === 0 ? "#BEF264" : "#22D3EE",
              boxShadow: `0 0 15px ${i % 3 === 0 ? "#BEF264" : "#22D3EE"}`,
              opacity: node.opacityBase * pulse,
              filter: "blur(1px)",
            }}
          />
        );
      })}

      {/* Ambient Gradient Glows */}
      <div
        style={{
          position: "absolute",
          top: "-20%",
          right: "-10%",
          width: "60%",
          height: "60%",
          background: "radial-gradient(circle, rgba(190, 242, 100, 0.08) 0%, transparent 70%)",
          filter: "blur(60px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-20%",
          left: "-10%",
          width: "60%",
          height: "60%",
          background: "radial-gradient(circle, rgba(34, 211, 238, 0.08) 0%, transparent 70%)",
          filter: "blur(60px)",
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
